import { parseTaskKey } from '@pm-tool/shared';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { requireTasksFeature } from '@/features/tasks/guard';
import { TaskPage } from '@/features/tasks/task-page';

/** TASK-05: shareable task URL /p/{KEY}/{KEY-123}; anything else under /p/{KEY} is unknown. */
export const Route = createFileRoute('/_app/p/$projectKey/$taskKey')({
  beforeLoad: async ({ context, params }) => {
    await requireTasksFeature(context.queryClient);
    if (parseTaskKey(params.taskKey) === null) throw notFound();
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { projectKey, taskKey } = Route.useParams();
  return <TaskPage projectKey={projectKey} taskKey={taskKey} />;
}
